module.exports = __webpack_public_path__ + "static/img/2.81788f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/2.png
// module id = /nX3
// module chunks = 0